import { useState } from "react";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import { TOAST_MESSAGES } from "../constants";
import toast from "react-hot-toast";
import {
    getSTL,
} from "../../../Services/inventoryService";
export const useSTL = () => {
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        warehouse: null,
    });
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const onPageChange = (newPage) => setPage(newPage);

    const onPageSizeChange = (newSize) => {
        setRowsPerPage(newSize);
        setPage(1);
    };

    const fetchAllSTLs = async (params) => {
        setLoading(true);
        var data = null;
        try {
            const response = await getSTL({
                ...filters,
                ...params,
                limit: rowsPerPage,
                offset: (page - 1) * rowsPerPage,
            });
            if (response.status === 200) {
                setTotalPages(
                    Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage))
                );
                data = response.data?.results;
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.STL_FETCH_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.STL_FETCH_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    return {
        loading,
        filters,
        setFilters,
        page,
        totalPages,
        rowsPerPage,
        onPageChange,
        onPageSizeChange,
        fetchAllSTLs,
    };
};
